export const resolveFnsku = (...items) => {
  for (const item of items) {
    if (!item) continue;

    const directValue = [
      item.fnsku,
      item.fulfillmentNetworkSku,
      item.seller_sku?.fnsku,
      item.sellerSku?.fnsku,
      item.sellersku?.fnsku,
      item.vendoritem?.seller_sku?.fnsku,
      item.vendor_item?.seller_sku?.fnsku,
      item.sku_info?.fnsku,
      item.skuInfo?.fnsku,
      item.products_v2?.[0]?.fnsku
    ].find(value => value && String(value).trim());

    if (directValue) return String(directValue).trim();

    const identifier = (item.product_details || item.productDetails || []).find((detail) => {
      const type = detail?.identifier_type || detail?.type || detail?.name;
      return String(type || '').toLowerCase() === 'fnsku';
    });

    const identifierValue = identifier?.identifier_value || identifier?.value || identifier?.fnsku;
    if (identifierValue && String(identifierValue).trim()) return String(identifierValue).trim();
  }

  return 'N/A';
};

export const findPackingItemBySkuId = (packingItems = [], skuId) => (
  packingItems.find(item => String(item.sku_id ?? item.id) === String(skuId)) || {}
);

export const buildPackNowLabelItems = ({ boxItems = [], packingItems = [], fallbackItem = {} }) => (
  boxItems.map((boxItem) => {
    const matchedItem = findPackingItemBySkuId(packingItems, boxItem?.sku_id);
    const fnsku = resolveFnsku(boxItem, matchedItem, fallbackItem);
    const quantity = Number(boxItem?.boxed_quantity || boxItem?.units || boxItem?.quantity || 0);
    const expiration = boxItem?.expiration || matchedItem?.expiration || fallbackItem?.expiration;

    return {
      sku_id: boxItem?.sku_id,
      fnsku,
      fulfillmentNetworkSku: fnsku,
      quantity,
      units: quantity,
      expiryDate: expiration ? [expiration] : []
    };
  })
);

export const formatBoxCode = (boxCode, boxId) => {
  if (!boxCode) return boxId ? `BX${boxId}` : 'BX01';
  return boxCode;
};
